<template>
  <div class="bubble-controls">
    <div class="row bubble-controls__tabs" style="padding-top: 0">
      <div class="col-xs-12 col-12 col-sm-12">
        <select-group-filter v-model="tab" @input="$emit('tab', tab)" :items="tabs" />
      </div>
    </div>
    <div class="row bubble-controls__filters" style="padding-top: 0">
      <div class="col-xs-12 col-12 col-sm-6">
        <select-filter
          v-model="category"
          :selections="categories"
          :label-icon="true"
          :fluid="true"
          @input="$emit('category', category)"
          label="Select category"
          style="margin: 0px !important"
        />
      </div>
      <div class="col-xs-12 col-12 col-sm-6 bubble-controls__filters__show-count">
        <switch-com
          class="switch"
          input-el-id="bubble-switch"
          label="Show count"
          v-model="showCount"
          @input="$emit('show-count', showCount)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectFilter from '@/components/ui/SelectFilter.vue';
import SelectGroupFilter from '@/components/ui/SelectGroupFilter.vue';
import SwitchCom from '@/components/ui/SwitchCom.vue';

export default {
  name: 'BubbleControls',
  components: {
    SwitchCom,
    SelectFilter,
    SelectGroupFilter,
  },
  props: {
    tabs: Array,
    categories: Array,
  },
  data: () => ({
    tab: 'New FinTech firms by year',
    category: 'Total Firms',
    showCount: false,
  }),
};
</script>

<style lang="scss" scoped>
.bubble-controls {
  &__tabs {
    padding-bottom: 20px;
  }

  &__filters {
    @media #{map-get($media-breakpoints, 'mobile')} {
      &__show-count {
        padding-top: 15px;
      }
    }
  }
}
.switch {
  /* md and up */
  @media only screen and (min-width: #{map-get($grid-breakpoints, 'sm')}) {
    float: right !important;
  }
}
</style>
